import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Grid } from '@mui/material';

function Footer2() {
    return (
        <Box
            sx={{
                backgroundColor: '#1111',
                color: '#9999',
                padding: '40px 20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mt: 'auto',
            }}
        >
            <Grid
                container
                justifyContent="center"
                spacing={4}
                sx={{
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {/* Quick Links Section */}
                <Grid
                    item
                    xs={12}
                    sm={10}
                    md={8}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 4,
                        flexWrap: 'wrap',
                    }}
                >
                    {[
                        { to: '/about-us', label: 'About' },
                        { to: '/faqs', label: 'FAQs' },
                        { to: '/careers', label: 'Careers' },
                        { to: '/contact-us', label: 'Contact' },
                        { to: '/community', label: 'Community' },
                        { to: '/customer-support', label: 'Help' },
                        { to: '/terms-of-service', label: 'Terms' },
                        { to: '/privacy-policy', label: 'Privacy' },
                        { to: '/cookies-policy', label: 'Cookies' },
                        { to: '/refunds-and-cancellations-policy', label: 'Refunds' },
                    ].map((link) => (
                        <Link
                            key={link.to}
                            to={link.to}
                            style={{
                                color: '#9999',
                                textDecoration: 'none',
                                padding: '5px',
                                letterSpacing: 2,
                                fontSize: 'clamp(0.75rem, 2vw, 1rem)', // responsive font size
                            }}
                        >
                            {link.label}
                        </Link>
                    ))}
                </Grid>

                {/* Copyright Section */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={8}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2,
                        flexDirection: { xs: 'column', sm: 'row' },
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="body2"
                        component="h1"
                        sx={{
                            fontSize: 'clamp(0.8rem, 2vw, 1rem)', // responsive font size
                            letterSpacing: 2,
                            '&:hover': {
                                color: 'white',
                            },
                        }}
                    >
                        © 2025 Anthrasync Inc. All rights reserved.
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Footer2;
